<template>
  <div class="layout-curation" v-show="shouldRender">
    <Header />
    <slot />
    <Footer v-if="!isExcludedRoute && !excludedRoutesOnlyFooter.includes(route.path)" />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import Header from '@/components/Header.vue';
import Footer from '@/components/Footer.vue';
import {isOnlyMobilePage, isPcWeb} from '@/utils/common';

const route = useRoute();
const shouldRender = ref<boolean>(false)

// 비노출 경로 설정
const excludedRoutes = [
  '/order/payNext'
];

// 특정 패턴을 포함하는 경로 숨기기
const noExcludedRoutes = [
  '/qr/link'
];

// 현재 경로가 비노출 대상인지 확인
const isExcludedRoute = computed(() =>
  excludedRoutes.includes(route.path) ||
  noExcludedRoutes.some(excluded => route.path.startsWith(excluded))
);

const excludedRoutesOnlyFooter = [
  '/order/cart'
];


if (import.meta.client && isPcWeb()) {
  //모바일 페이지만 잇는경우 (선물받기페이지) 진입시 제외
  if(isOnlyMobilePage()){
    shouldRender.value = true;
  } else{
    goStoreTtobakCare();
  }
} else if(import.meta.client ){
  shouldRender.value = true;
}

</script>

<style lang="scss">
  @use '@/assets/scss/layout.scss'; // 기본 레이아웃(2025-03-19 리뉴얼)
</style>

<style lang="scss" scoped>
.layout-header {
  // background-image:var(--hecto-bg-primary-gradient);
  background-color: #fff;
}
</style>